

import { __ } from '@wordpress/i18n';

export const resourceOpt = [
	{ label: __('Channel', 'yt-video-gallery'), value: 'channel' },
	{ label: __('Playlist ', 'yt-video-gallery'), value: 'playlist' },
]

export const orderByOpt = [
	{ label: __('Date', 'yt-video-gallery'), value: 'date' },
	{ label: __('Rating ', 'yt-video-gallery'), value: 'rating' },
	{ label: __('Title', 'yt-video-gallery'), value: 'title' },
	// { label: __('Video Count', 'yt-video-gallery'), value: 'videoCount' },
	// { label: __('View Count ', 'yt-video-gallery'), value: 'viewCount ' }
]

export const layouts = [
	{ label: __('Default', 'yt-video-gallery'), value: 'default' },
	{ label: __('Grid Details', 'yt-video-gallery'), value: 'grid-details' },
	{ label: __('Playlist', 'yt-video-gallery'), value: 'playlist' }
];

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'yt-video-gallery') },
	{ name: 'style', title: __('Style', 'yt-video-gallery') }
];